import React, { useEffect, useContext, useState } from "react";
import LastTransactions from "./LastTransactions";
import TotalIncome from "./TotalIncome";
import DashboardNumeric from "./DashboardNumerics";
import DealsPerformance from "./DealsPerformance";
import ActiveDeals from "./ActiveDeals";
import { UserContext } from "../../App";
import download from "../../images/Download.svg";
import MainContainer from "../../container/MainContainer";
import NewModal from "../Common/NewModal";
import moment from "moment";
import DateFilter from "./DateFilter";
import { Dropdown } from "react-bootstrap";
import html2pdf from "html2pdf.js";
import PdfPrint from "./PdfPrint";
import TermsAndConditionPopup from "../TermsAndConditionPopup/TermsAndConditionPopup";
import MembershipFormPopup from "../TermsAndConditionPopup/MembershipFormPopup";
import MembershipSuccessPopup from "../TermsAndConditionPopup/MembershipSuccessPopup";

const DashboardLayout = () => {
  const { setuserContextState } = useContext(UserContext);
  const [newModalOpen, setNewModalOpen] = useState(false);
  const [isTandCModalOpen, setIsTandCModalOpen] = useState(false);
  const [isMemberShipModalOpen, setIsMemberShipModalOpen] = useState(false);
  const [isSuccessMemberShipModalOpen, setIsSuccessMemberShipModalOpen] =
    useState(false);

  const [startDate, setStartDate] = useState(
    moment(getPreviousMonday()).format()
  );
  const [endDate, setEndDate] = useState(moment().format());
  const [comparisonStartDate, setComparisonStartDate] = useState(
    new Date(moment(getPreviousMonday()).subtract(7, "days").format())
  );
  const [comparisonEndDate, setComparisonEndDate] = useState(
    new Date(moment(getPreviousMonday()).subtract(1, "days").format())
  );
  const [diffDay, setDiffDay] = useState(6);

  const [startDateRange, setStartDateRange] = useState(new Date());
  const [endDateRange, setEndDateRange] = useState(null);
  const [isPrint, setIsPrint] = useState(false);

  const [isOpenFil, setIsOpenFil] = useState(false);

  function getPreviousMonday() {
    var date = new Date();
    var day = date.getDay();
    var prevMonday = new Date();
    if (date.getDay() == 0) {
      prevMonday.setDate(date.getDate() - 7);
    } else {
      prevMonday.setDate(date.getDate() - (day - 1));
    }

    return prevMonday;
  }

  useEffect(() => {
    if (localStorage.getItem("term_and_conditions")) {
      if (!JSON.parse(localStorage.getItem("term_and_conditions"))) {
        setIsTandCModalOpen(true);
      }
      return;
    }
    if (!localStorage.getItem("isnewuser")) {
      localStorage.setItem("isnewuser", true);
      setNewModalOpen(true);
    }
  }, []);

  const handleChange = (selectedOption) => {
    if (selectedOption.value === "this_week") {
      setStartDate(moment(getPreviousMonday()).format());
      setEndDate(moment().format());
      setComparisonStartDate(
        moment(getPreviousMonday()).subtract(7, "days").format()
      );
      setComparisonEndDate(
        moment(getPreviousMonday()).subtract(1, "days").format()
      );
      setDiffDay(6);
    } else if (selectedOption.value === "this_month") {
      setStartDate(
        moment()
          .subtract(moment().format("DD") - 1, "days")
          .format()
      );
      setEndDate(moment().format());
      setComparisonStartDate(
        moment(moment().subtract(moment().format("DD"), "days").format())
          .subtract(
            moment().subtract(moment().format("DD"), "days").format("DD") - 1,
            "days"
          )
          .format()
      );
      setComparisonEndDate(
        moment().subtract(moment().format("DD"), "days").format()
      );
      setDiffDay(
        moment().format("DD") -
          moment()
            .subtract(moment().format("DD") - 1, "days")
            .format("DD")
      );
    } else if (selectedOption.value === "this_quarter") {
      setStartDate(moment().subtract(125, "day").format());
      setEndDate(moment().format());

      setComparisonStartDate(
        moment(moment().subtract(125, "day").format())
          .subtract(125, "day")
          .format()
      );
      setComparisonEndDate(moment().subtract(125, "day").format());

      setDiffDay(125);
    } else if (selectedOption.value === "this_year") {
      setStartDate(moment().startOf("year").format());
      setEndDate(moment().format());
      setComparisonStartDate(
        parseInt(
          moment(moment().startOf("year").format())
            .subtract(365, "days")
            .format("DD")
        ) === 1
          ? moment(moment().startOf("year").format())
              .subtract(365, "days")
              .format()
          : moment(moment().startOf("year").format())
              .subtract(366, "days")
              .format()
      );
      setComparisonEndDate(
        moment(moment().startOf("year").format()).subtract(1, "days").format()
      );
      setDiffDay(366);
    } else if (selectedOption.value === "custom_date") {
      setStartDate(new Date());
      setEndDate(null);
    }
  };

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDateRange(start);
    setEndDateRange(end);
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      let startDay = new Date(start).getTime();

      let endDay = new Date(end).getTime();

      setDiffDay((endDay - startDay) / (1000 * 3600 * 24));

      setComparisonStartDate(
        moment(start)
          .subtract((endDay - startDay) / (1000 * 3600 * 24) + 1, "days")
          .format()
      );

      setComparisonEndDate(moment(start).subtract(1, "days").format());

      setIsOpenFil(false);
    }
  };

  var opt = {
    filename: `${"dashboard"}.pdf`,
    html2canvas: {
      dpi: 144,
      scale: 2,
      letterRendering: true,
      useCORS: true,
    },
    jsPDF: { unit: "mm", format: "a3", orientation: "portrait" },
  };

  const downloadAsPDF = () => {
    const inv = document.getElementById("pdf_print");
    html2pdf().from(inv).set(opt).save();
    setTimeout(() => {
      setIsPrint(false);
    }, 1);
  };

  return (
    <MainContainer active="dashboard">
      {isTandCModalOpen ? (
        <TermsAndConditionPopup
          setIsTandCModalOpen={setIsTandCModalOpen}
          setNewModalOpen={setNewModalOpen}
          setIsMemberShipModalOpen={setIsMemberShipModalOpen}
          show={true}
        />
      ) : null}
      {isMemberShipModalOpen && (
        <MembershipFormPopup
          show={true}
          setNewModalOpen={setNewModalOpen}
          setIsMemberShipModalOpen={setIsMemberShipModalOpen}
          setIsSuccessMemberShipModalOpen={setIsSuccessMemberShipModalOpen}
        />
      )}
      {isSuccessMemberShipModalOpen && (
        <MembershipSuccessPopup
          show={true}
          setNewModalOpen={setNewModalOpen}
          setIsSuccessMemberShipModalOpen={setIsSuccessMemberShipModalOpen}
        />
      )}
      {newModalOpen ? (
        <NewModal
          setNewModalOpen={setNewModalOpen}
          show={true}
          setuserContextState={setuserContextState}
        />
      ) : (
        <div className="main-inner">
          <div className="dashboard-title">
            <h1>Dashboard</h1>
            <div className="dashbaord-header-right">
              <Dropdown
                onClick={() => {
                  setIsOpenFil(false);
                }}
              >
                <Dropdown.Toggle
                  className="download-btn"
                  variant="success"
                  id="dropdown-basic"
                >
                  <img src={download} alt="download" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      setIsPrint(true);
                      setTimeout(() => {
                        downloadAsPDF();
                      }, 2000);
                    }}
                  >
                    Export as PDF
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <DateFilter
                handleChange={handleChange}
                onChange={onChange}
                startDate={startDateRange}
                endDate={endDateRange}
                setIsOpenFil={setIsOpenFil}
                isOpenFil={isOpenFil}
              />
            </div>
          </div>

          <DashboardNumeric
            startDate={startDate}
            endDate={endDate}
            comparisonStartDate={comparisonStartDate}
            comparisonEndDate={comparisonEndDate}
          />
          <div className="dashboard-row">
            <div className="dashboard-col-left">
              <TotalIncome
                diffDay={diffDay}
                setDiffDay={setDiffDay}
                startDate={startDate}
                endDate={endDate}
              />
            </div>
            <div className="dashboard-col-right">
              <LastTransactions />
            </div>
          </div>
          <div className="dahsboard-second-row">
            <div className="col-left-1">
              <DealsPerformance />
            </div>
            <div className="col-right-1">
              <ActiveDeals />
            </div>
          </div>
          {isPrint ? (
            <PdfPrint
              TotalIncome={TotalIncome}
              diffDay={diffDay}
              setDiffDay={setDiffDay}
              startDate={startDate}
              endDate={endDate}
              comparisonStartDate={comparisonStartDate}
              comparisonEndDate={comparisonEndDate}
            />
          ) : (
            ""
          )}
        </div>
      )}
    </MainContainer>
  );
};

export default DashboardLayout;
